import React, {Component} from 'react'
import {message, Modal, Upload} from "antd";
import {PlusOutlined} from "@ant-design/icons";
import {BLOG_IMAGE_UPLOAD_URL, LOG_OUT} from "../constants";
import BlogService from '../services/blog.service';
import i18n from "i18next";
import AuthService from "../services/auth.service";

export default class PictureUploader extends Component {

    constructor(props) {
        super(props);

        this.state = {
            blogId: props.blogId,
            showImagePreview: false,
            previewTitle: "",
            previewURL: "",
            images: []
        }

        setTimeout(function () {
            this.blogImages();
        }.bind(this), 571);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.blogId !== this.props.blogId) {
            setTimeout(function () {
                this.blogImages();
            }.bind(this), 571);
        }
    }

    blogImages = () => {

        const {blogId} = this.props;

        BlogService.blogImages(blogId)
            .then(
                response => {
                    if (response.data.success === true) {
                        this.setState({
                            images: response.data.images
                        });
                    } else {
                        message.error(i18n.t('global_error'))
                    }
                },
                error => {
                    if (error.response && error.response.status === 401) {
                        AuthService.logout()
                        this.props.userAction(LOG_OUT)

                        message.error(i18n.t('login_expired'))
                    } else {
                        message.error(i18n.t('global_error'))
                    }
                }
            )
    }

    handleCancel = () => {
        this.setState({
            showImagePreview: false
        });
    }

    handlePreview = async (file) => {

        console.log(file);

        this.setState({
            showImagePreview: true,
            previewTitle: file.name,
            previewURL: file.url
        });
    }

    handleChange = (changeRequest) => {
    }

    uploadingError = () => {
        this.setState({
            images: this.state.images.filter(file => file.uid !== "uploading")
        });
    }

    uploading = (file) => {

        let freshImages = this.state.images;
        freshImages.push({uid: "uploading", name: file.name, status: "uploading"});

        this.setState({
            images: freshImages
        });
    }

    handleBeforeUpload = (file) => {

        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        const isLt13M = file.size / 1024 / 1024 < 13;
        if (!isJpgOrPng) {
            message.error('Sadece JPG/PNG dosyaları yükleyin!');
        } else if (!isLt13M) {
            message.error('Resmin boyutu max 13MB olabilir!');
        } else {
            this.uploading(file);

            setTimeout(function () {
                this.uploadToServer(file);
            }.bind(this), 571);
        }

        return false
    }

    uploadToServer = (file) => {

        const {blogId} = this.props;
        const formData = new FormData();
        formData.append('file', file);

        BlogService.saveBlogImage(blogId, formData)
            .then(
                response => {
                    if (response.data.success === true) {
                        this.setState({
                            images: response.data.images
                        });
                    } else {
                        this.uploadingError();
                        message.error(i18n.t('global_error'))
                    }
                },
                error => {
                    this.uploadingError();

                    if (error.response && error.response.status === 401) {
                        AuthService.logout()
                        this.props.userAction(LOG_OUT)

                        message.error(i18n.t('login_expired'))
                    } else {
                        message.error(i18n.t('global_error'))
                    }
                }
            )
    }

    handleRemove = (file) => {

        const {blogId} = this.props;

        BlogService.deleteBlogImage(blogId, file.fileId)
            .then(
                response => {
                    if (response.data.success === true) {
                        this.setState({
                            images: response.data.images
                        });
                    } else {
                        message.error(i18n.t('global_error'))
                    }
                },
                error => {
                    if (error.response && error.response.status === 401) {
                        AuthService.logout()
                        this.props.userAction(LOG_OUT)

                        message.error(i18n.t('login_expired'))
                    } else {
                        message.error(i18n.t('global_error'))
                    }
                }
            )

        return false
    }

    render() {
        const {images, showImagePreview, previewTitle, previewURL} = this.state;
        const {blogId} = this.props;

        return (
            <>
                <Upload
                    action={BLOG_IMAGE_UPLOAD_URL + blogId}
                    beforeUpload={this.handleBeforeUpload}
                    onPreview={this.handlePreview}
                    onRemove={this.handleRemove}
                    listType="picture-card"
                    fileList={images}
                >
                    {images.length >= 8
                        ? null
                        : <div>
                            <PlusOutlined/>
                            <div style={{marginTop: 8}}>Yeni Resim</div>
                        </div>}
                </Upload>
                <Modal
                    visible={showImagePreview}
                    title={previewURL}
                    footer={null}
                    width={751}
                    onCancel={this.handleCancel}>

                    <label>{previewTitle}</label>
                    <img alt={previewTitle} style={{width: '100%', maxHeight: '751px'}} src={previewURL}/>

                </Modal>
            </>
        )
    }
}